import { Button } from '@mui/material';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import SwapVertIcon from '@mui/icons-material/SwapVert';

export type GenericSortListButtonProps = {
    path: string;
};
export const GenericSortListButton = (props: GenericSortListButtonProps) => {
    return (
        <Button component={Link} to={props.path}>
            <SwapVertIcon />
            <FormattedMessage
                defaultMessage="Sort"
                description="Button label to open a sort list dialog"
            />
        </Button>
    );
};
